import { PERSON_TYPE } from 'enums/enums'
import { FileExtension } from './fileFunction'

const SIMULATION_INFO = 'simulation-info'
export const isAdult = (value: Date) => {
  const storageSimulation = localStorage.getItem(SIMULATION_INFO)
  if (!storageSimulation) return false
  const storage = JSON.parse(storageSimulation)

  const { idade_venda_menor } = storage.state

  const dateOfBirth = new Date(value)

  const eighteenYearsAgo = new Date()
  eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - idade_venda_menor)

  return dateOfBirth <= eighteenYearsAgo
}
export const CPFtoString = (cpf: string) => {
  return cpf.replace(/\D/g, '') // Remove todos os caracteres não numéricos
}
export const downloadPDF = (pdfBase64: string, documentName: string) => {
  const byteCharacters = atob(pdfBase64)

  const byteNumbers = new Array(byteCharacters.length)
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i)
  }
  const byteArray = new Uint8Array(byteNumbers)

  const blob = new Blob([byteArray], { type: 'application/pdf' })

  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = documentName
  link.click()
  URL.revokeObjectURL(url)
}

export const formatCep = (value: string) => {
  if (value.length > 8) return value.slice(0, 9)
  const cep = value.replace(/\D/g, '')
  return cep.replace(/(\d{5})(\d{3})/, '$1-$2')
}

export const isElderly = (date: Date) => {
  const storageSimulation = localStorage.getItem(SIMULATION_INFO)
  if (!storageSimulation) return false
  const { idade_venda_maior } = JSON.parse(storageSimulation).state

  if (date.getFullYear() < 1900) return
  const today = new Date()
  const age = today.getFullYear() - date.getFullYear()

  return age <= idade_venda_maior
}

export const isNotAfterToday = (date: Date) => {
  const today = new Date()
  return date > today
}

export const isAfterDate = (date: Date, otherDate: Date) => {
  return date > otherDate
}

type DocumentInfo = {
  cd_inscricao_nacional_app: string
  person_type: PERSON_TYPE
}

export function checkDocument(document: string): DocumentInfo {
  const cleanDocument = document.replace(/[^a-zA-Z0-9]/g, '')
  if (cleanDocument.length === 11) {
    return {
      cd_inscricao_nacional_app: cleanDocument,
      person_type: PERSON_TYPE.Fisico
    }
  } else if (cleanDocument.length === 14) {
    return {
      cd_inscricao_nacional_app: cleanDocument,
      person_type: PERSON_TYPE.Juridico
    }
  } else {
    throw new Error('Documento inválido')
  }
}

export function getMimeTypeFromExtension(extension: FileExtension) {
  const mimeTypes = {
    pdf: 'application/pdf',
    svg: 'image/svg+xml',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    gif: 'image/gif',
    txt: 'text/plain',
    html: 'text/html',
    css: 'text/css',
    js: 'application/javascript',
    json: 'application/json',
    xml: 'application/xml',
    mp3: 'audio/mpeg',
    mp4: 'video/mp4'
  }

  return mimeTypes[extension] || 'application/octet-stream' // Use 'application/octet-stream' como padrão se a extensão não for encontrada
}

type checkIfApplyDiscontByDocumentParams = {
  cd_inscricao_nacional_app: string
  id_desconto_document: number
  checkboxDiscontTax: boolean
}
export const checkIfApplyDiscontByDocument = ({
  checkboxDiscontTax,
  cd_inscricao_nacional_app,
  id_desconto_document
}: checkIfApplyDiscontByDocumentParams) => {
  if (checkboxDiscontTax && cd_inscricao_nacional_app && id_desconto_document) {
    return id_desconto_document
  }
  return 0
}

export const isCepValid = (cep: string) => {
  const numericCep = cep.replace(/\D/g, '')
  return numericCep.length === 8
}

function calculateAge(date: Date) {
  const today = new Date()
  let age = today.getFullYear() - date.getFullYear()
  const monthDiff = today.getMonth() - date.getMonth()
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < date.getDate())) {
    age--
  }
  return age
}

// Pessoa física: idade mínima de 18 anos
export function isAgeValid(date: Date) {
  const adultAge = 18
  const elderlyLimit = 120
  const age = calculateAge(date)
  return age >= adultAge && age <= elderlyLimit
}

export function sortStrings(a: string, b: string) {
  if (a < b) {
    return -1
  }
  if (a > b) {
    return 1
  }
  return 0
}

export function naturalSort(a: string, b: string): number {
  const regex = /(\d+|\D+)/g // Captura números e partes não numéricas
  const chunksA = a.match(regex) || []
  const chunksB = b.match(regex) || []

  for (let i = 0; i < Math.max(chunksA.length, chunksB.length); i++) {
    const chunkA = chunksA[i] || ''
    const chunkB = chunksB[i] || ''

    // Comparar como números se ambos forem numéricos
    if (!isNaN(Number(chunkA)) && !isNaN(Number(chunkB))) {
      const diff = Number(chunkA) - Number(chunkB)
      if (diff !== 0) return diff
    } else {
      // Comparar como strings se não forem numéricos
      const diff = chunkA.localeCompare(chunkB)
      if (diff !== 0) return diff
    }
  }

  return 0 // Iguais
}
